import React from "react";

import { ConvertIcon } from "components/icons/ConvertIcon";
import { WalletIcon } from "components/icons/WalletIcon";
import { ArchiveIcon } from "components/icons/ArchiveIcon";
import { EditAccountIcon } from "components/icons/EditAccountIcon";
import { FillConvertIcon } from "components/icons/FillConvertIcon";
import { FillArchiveIcon } from "components/icons/FillArchiveIcon";
import { FillWalletIcon } from "components/icons/FillWalletIcon";
import blueEmailIcon from "assets/icons/blueEmailIcon.svg";

export const sidebarMenuItems: any[] = [
  {
    icon: <ConvertIcon />,
    activeIcon: <FillConvertIcon />,
    id: 1,
    path: "convert-text-to-speech",
    title: "تبدیل متن به گفتار",
  },
  {
    icon: <ArchiveIcon />,
    activeIcon: <FillArchiveIcon />,
    id: 2,
    path: "archive",
    title: "آرشیو",
  },
  {
    icon: <WalletIcon />,
    activeIcon: <FillWalletIcon />,
    id: 3,
    path: "wallet",
    title: "کیف پول",
  },
  {
    icon: <EditAccountIcon />,
    activeIcon: "",
    id: 4,
    path: "edit-account",
    title: "ویرایش حساب",
  },
  {
    icon: <img src={blueEmailIcon} />,
    activeIcon: "",
    id: 5,
    path: "support",
    title: "تماس با ما",
  },
];
